import React from 'react';
import { CheckCircle2, XCircle, Clock, HandCoins } from 'lucide-react';
import { typeMeta, fmtDateTime, fmtDate, fmtMoney, StateBadge } from './crmHelpers';

const SendStatus = ({ status }) => {
  if (!status) return null;
  const map = { sent: ['Enviado', 'text-emerald-700 bg-emerald-50', CheckCircle2], failed: ['Envío fallido', 'text-red-700 bg-red-50', XCircle] };
  const [label, cls, Icon] = map[status] || ['Pendiente', 'text-slate-600 bg-slate-100', Clock];
  return <span className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-medium ${cls}`}><Icon className="w-3 h-3" />{label}</span>;
};

const PromiseChip = ({ promise }) => {
  const cls = { pending: 'bg-violet-50 text-violet-800 border-violet-200', kept: 'bg-emerald-50 text-emerald-800 border-emerald-200', broken: 'bg-red-50 text-red-700 border-red-200' }[promise.status] || '';
  const label = { pending: 'Pendiente', kept: 'Cumplida', broken: 'Incumplida' }[promise.status] || promise.status;
  return (
    <div className={`mt-1.5 inline-flex items-center gap-2 rounded-md border px-2 py-1 text-xs ${cls}`} data-testid="crm-promise-chip">
      <HandCoins className="w-3.5 h-3.5" />Promesa: {fmtMoney(promise.amount)} para el {fmtDate(promise.date)} · <b>{label}</b>
    </div>
  );
};

const CrmTimeline = ({ interactions }) => {
  if (!interactions.length) return <p className="text-sm text-slate-400 text-center py-6" data-testid="crm-timeline-empty">Todavía no hay gestiones registradas.</p>;
  return (
    <ol className="relative border-l border-slate-200 ml-3 space-y-4" data-testid="crm-timeline">
      {interactions.map((it) => {
        const meta = typeMeta(it.type); const Icon = meta.icon;
        return (
          <li key={it.id} className="ml-5" data-testid={`crm-interaction-${it.id}`}>
            <span className={`absolute -left-[13px] mt-0.5 flex h-6 w-6 items-center justify-center rounded-full ring-4 ring-white ${meta.bg}`}><Icon className={`w-3.5 h-3.5 ${meta.color}`} /></span>
            <div className="rounded-lg border border-slate-100 bg-white px-3 py-2 shadow-sm">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-semibold text-slate-800">{meta.label}</span>
                {it.response_type_name && <StateBadge state={{ name: it.response_type_name, color: it.response_color || '#64748b' }} />}
                {it.type === 'state_change' && <span className="text-xs text-slate-600">{it.state_from || '—'} → <b>{it.state_to}</b></span>}
                {it.type !== 'state_change' && it.state_to && <span className="text-[10px] text-slate-500">→ estado {it.state_to}</span>}
                <SendStatus status={it.send_status} />
                <span className="ml-auto text-[11px] text-slate-400">{fmtDateTime(it.created_at)} · {it.user_name}</span>
              </div>
              {it.contact_value && <p className="text-[11px] text-slate-500 mt-0.5">Contacto: {it.contact_value}</p>}
              {it.message && <p className="text-xs text-slate-700 mt-1 whitespace-pre-wrap border-l-2 border-emerald-200 pl-2">{it.subject ? <b>{it.subject}: </b> : null}{it.message}</p>}
              {it.notes && <p className="text-sm text-slate-700 mt-1 whitespace-pre-wrap">{it.notes}</p>}
              {it.promise && <PromiseChip promise={it.promise} />}
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default CrmTimeline;
